import { useQuery } from '@tanstack/react-query'
import { queryOptions } from '@tanstack/react-query'
import { ApiError, apiGet } from '../../api/client'
import { LoadFailed } from '../../ui/LoadFailed'
import { Spinner } from '../../ui/Spinner'

/**
 * Settings → Easeedesk → [Portal] Notifications.
 *
 * Element cu element fata de `version-3/easeedesk_settings/notifications/
 * portal_notifications/index.php`.
 *
 * COMUTATORUL NU SALVEAZA NIMIC, SI NU SALVA NICI IN PORTAL: n-are `name`,
 * n-are stare citita din baza, formularul lui arata spre
 * `settings/easeedesk/enable_portal_notifications` - o metoda care nu exista -
 * si `index-1.js` nici macar nu trimite formularul. Se muta ca atare, fiindca
 * stergerea unui ecran din bara e o hotarare de om. Vezi
 * `SettingsEaseedeskPortalNotificationsController`.
 */

export interface PortalNotificationsShell {
  title: string
  moduleUrl: string
  saves: boolean
}

export function portalNotificationsShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'portal_notifications'],
    queryFn: () => apiGet<PortalNotificationsShell>('/settings/easeedesk/portal_notifications'),
  })
}

export function PortalNotificationsPage() {
  const shell = useQuery(portalNotificationsShellQuery())

  if (shell.error instanceof ApiError && shell.error.status === 403) {
    return (
      <div className="alert alert-danger">
        <i className="fas fa-exclamation-circle" aria-hidden="true"></i> You do not have access to this action.
      </div>
    )
  }
  if (shell.error) {
    return <LoadFailed error={shell.error} onRetry={() => void shell.refetch()} what="this screen" />
  }
  if (!shell.data) return <Spinner />

  return (
    <div>
      <h4>
        <strong>[Portal] Notifications</strong> settings
      </h4>
      <hr />

      <section className="settings">
        <div className="row">
          <div className="col-md-2">
            <h5 style={{ marginBottom: 20 }}>Enable notifications</h5>
          </div>
          <div className="col-md-10">
            <div className="form-group row">
              <div className="col-md-12">
                {/*
                  `saves` vine de la server si spune ca aici NU se salveaza
                  nimic - comutatorul n-avea `name`, n-avea stare citita din
                  baza, iar formularul arata spre o metoda care nu exista.
                  Pana acum raspunsul se cerea si se arunca: omul muta
                  comutatorul, nu se intampla nimic, si nimic nu-i spunea de ce.
                  Acum i se spune, iar comutatorul e blocat - un buton care nu
                  face nimic si se lasa apasat e mai rau decat unul stins.
                */}
                <input type="checkbox" defaultChecked={false} disabled={!shell.data.saves} />
                <span className="help-block">
                  These notifications can be found in the header{' '}
                  <i className="far fa-bell font-20" aria-hidden="true"></i>.
                </span>
                {!shell.data.saves && (
                  <div className="note note-info" style={{ marginTop: 10 }}>
                    <i className="fas fa-info-circle" aria-hidden="true"></i> This switch is not connected to anything
                    yet: the setting has nowhere to be saved, so it stays off. Nothing is lost when you leave the page.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <hr className="dotted" />
      </section>
    </div>
  )
}
